import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'

export const Confire = () => {
     const [showModal, setShowModal] = useState(false)
     const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
     const handleOpenModal = (contentType, category, index, maxIndex) => {
         setModalContent({ contentType, category, index, maxIndex })
         setShowModal(true)
     }
     const handleCloseModal = () => {
         setModalContent({ contentType: '', category: '', index: 0 })
         setShowModal(false)
     }
    return (
        <>
            <div className='flex justify-center '>
                <img
                    className=''
                    alt='gadget'
                    src={`${process.env.PUBLIC_URL}/images/system/system-header-gadget.png`}
                />
            </div>{' '}
            <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                <p>Trees and rocks aren't the only things you can Confine to!</p>
                <p className='mt-4'>
                    If Apricot is with you, she can airdrop{' '}
                    <span className='text-pborange'> robots, tanks with gigantic cannons, and flying Gadgets</span> onto
                    the map! <span className='text-pborange'> "Confiring" </span>to these can increase your attack
                    range, let you suck in all kinds of objects, and perform a variety of other actions. Think of the
                    strategic possibilities!
                </p>{' '}
                <div className='flex mt-8'>
                    <div className='w-full md:w-4/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal('image', 'gadget', 1)
                            }}
                            className='ss-thumb'
                            alt='screenshot of game system'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-gadget-1-s.webp`}
                        />
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            Gadgets can be developed and enhanced at your base on Skullrock Island.
                        </p>
                    </div>
                </div>{' '}
                <div className='flex mt-8'>
                    <div className='w-full md:w-3/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal('image', 'gadget', 2)
                            }}
                            className='ss-thumb'
                            alt='screenshot of game system'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-gadget-2-s.webp`}
                        />
                    </div>
                </div>{' '}
            </div>{' '}
            <div className='flex justify-center mt-12'>
                <img
                    className=''
                    alt='more gadgets map'
                    src={`${process.env.PUBLIC_URL}/images/system/system-header-mapgadget.png`}
                />
            </div>{' '}
            <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                <p className='mt-4'>
                    On some maps, you'll find Gadgets like cannons, catapults, fans, and even slot machines. When
                    approaching these Gadgets, the player will be able to perform a variety of actions, and if a Phantom
                    is Confined to one, additional special actions will become available. Gadgets could be the{' '}
                    <span className='text-pborange'>key to conquering these maps</span>!
                </p>{' '}
                <div className='flex mt-8'>
                    <div className='w-full md:w-3/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal('image', 'gadget', 3)
                            }}
                            className='ss-thumb'
                            alt='screenshot of game system'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-gadget-3-s.webp`}
                        />{' '}
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            Slot machines may contain rare items!
                        </p>
                    </div>
                </div>{' '}
            </div>{' '}
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={3}
            />
        </>
    )
}
